module.exports = __webpack_public_path__ + "img/logo-3.d6c1652c.png";